import React, { useState, useEffect } from 'react';
import { Gauge, Car, ChevronRight, Droplet, AlertTriangle, CheckCircle2 } from 'lucide-react';
import axiosInstance from '../../utils/axiosConfig';
import toast from 'react-hot-toast';
import VehiculoHistorialModal from './VehiculoHistorialModal';

const fmtKm = (val) => Number(val).toLocaleString('es-VE');

const ESTADO_CFG = {
  OK: { label: 'Al día', badge: 'bg-emerald-50 text-emerald-600 border-emerald-100', icon: CheckCircle2 },
  PROXIMO: { label: 'Próximo cambio', badge: 'bg-amber-50 text-amber-600 border-amber-100', icon: AlertTriangle },
  VENCIDO: { label: 'Cambio vencido', badge: 'bg-red-50 text-red-600 border-red-100', icon: AlertTriangle },
};

const VehiculoCard = ({ vehiculo, onClick }) => {
  const cfg = ESTADO_CFG[vehiculo.estado_mtto] || ESTADO_CFG.OK;
  const Icon = cfg.icon;

  return (
    <button
      onClick={onClick}
      className="w-full text-left bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-sura-blue/30 transition-all p-5 group"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3.5 min-w-0">
          <div className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 bg-sura-blue/10 text-sura-blue">
            <Car size={20} />
          </div>
          <div className="min-w-0">
            <h3 className="font-bold text-gray-900 text-base truncate">{vehiculo.nombre}</h3>
            <p className="text-sm text-gray-400 font-mono">{fmtKm(vehiculo.kilometraje_actual)} km actuales</p>
          </div>
        </div>
        <ChevronRight size={20} className="text-gray-300 group-hover:text-sura-blue group-hover:translate-x-0.5 transition-all flex-shrink-0" />
      </div>

      <div className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg mt-3.5 w-fit border ${cfg.badge}`}>
        <Icon size={13} />
        <span className="text-xs font-semibold">{cfg.label}</span>
      </div>
    </button>
  );
};

const ReportesKmTab = () => {
  const [vehiculos, setVehiculos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(null);

  const fetchVehiculos = () => axiosInstance.get('/api/equipos-moviles/vehiculos')
    .then(res => setVehiculos(res.data))
    .catch(error => {
      console.error(error);
      toast.error('Error al cargar los vehículos');
    })
    .finally(() => setLoading(false));

  useEffect(() => {
    fetchVehiculos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sura-blue"></div>
      </div>
    );
  }

  if (vehiculos.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center bg-white rounded-2xl border border-gray-100">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3 bg-sura-blue/10">
          <Gauge size={26} className="text-sura-blue" />
        </div>
        <h3 className="text-gray-800 font-semibold mb-1">Aún no hay vehículos registrados</h3>
        <p className="text-gray-400 text-sm">Agrega vehículos en la pestaña "Vehículos y KM" para ver su historial aquí</p>
      </div>
    );
  }

  return (
    <div>
      <p className="text-sm text-gray-400 mb-4 flex items-center gap-1.5">
        <Droplet size={13} /> Haz clic en un vehículo para ver y editar su historial completo
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {vehiculos.map(v => (
          <VehiculoCard key={v.id} vehiculo={v} onClick={() => setVehiculoSeleccionado(v)} />
        ))}
      </div>

      <VehiculoHistorialModal
        isOpen={!!vehiculoSeleccionado}
        vehiculo={vehiculoSeleccionado}
        onClose={() => setVehiculoSeleccionado(null)}
        onChange={fetchVehiculos}
      />
    </div>
  );
};

export default ReportesKmTab;
